import bytes from 'bytes';

export class FormattingUtility {
	public static bytesAsGB(size: number | string): string {
		return bytes(size as any, {
			unit: 'GB',
			decimalPlaces: 1,
			unitSeparator: ' '
		});
	}
	public static bytesAsFriendly(size: number | string): string {
		return bytes(size as any, {
			decimalPlaces: 1,
			unitSeparator: ' '
		});
	}
}
